/**
 * 获取多边形的中心点
 * @param {*} lnglatarr
 */
export const getTheAreaCenter = lnglatarr => {
  const total = lnglatarr.length;
  let X = 0;
  let Y = 0;
  let Z = 0;
  lnglatarr.forEach(item => {
    const lng = (item[0] * Math.PI) / 180;
    const lat = (item[1] * Math.PI) / 180;
    const x = Math.cos(lat) * Math.cos(lng);
    const y = Math.cos(lat) * Math.sin(lng);
    const z = Math.sin(lat);
    X += x;
    Y += y;
    Z += z;
  });

  X /= total;
  Y /= total;
  Z /= total;

  const Lng = Math.atan2(Y, X);
  const Hyp = Math.sqrt(X * X + Y * Y);
  const Lat = Math.atan2(Z, Hyp);
  return [(Lng * 180) / Math.PI, (Lat * 180) / Math.PI];
};

/**
 * 图表默认色值
 * */
export const chartColor = () => {
  return [
    '#2962FF',
    '#03C98C',
    '#FF8400',
    '#AA25FF',
    '#FFD000',
    '#80D8FF',
    '#FF8A80',
    '#B8C32C',
    '#EA80FC',
    '#82B1FF',
  ];
};
